import HttpClient from './index';

const servicePath = '/api/v3/user';
const osstmofiberPath = '/api/v3/osstmofiber';

/**
 * @param email
 * @param secret
 * @return {AxiosPromise}
 */
export const lfAuth = token => HttpClient({
    method: 'POST',
    url: `${servicePath}/social_authentication`,
    headers: {
        'Content-Type': 'application/json',
    },
    data: {
        operator_name: process.env.VUE_APP_LF_OPERATOR,
        application_id: process.env.VUE_APP_LF_APP_ID,
        social_network: 'azure',
        social_token: token,
    },
});

/**
 * @param accountId
 * @return {AxiosPromise}
 */
export function getAccount(accountId) {
    return HttpClient({
        method: 'POST',
        url: `${servicePath}/get_account`,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        },
        data: {
            target_id: accountId,
            target_type: 2,
        },
    });
}

export function updateResourceMap(externalServiceId, accountId) {
    return HttpClient({
        method: 'POST',
        url: `${servicePath}/update_resource_map`,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        },
        data: {
            target_id: accountId,
            target_type: 2,
            resource_map: {
                external_service_id: externalServiceId,
            },
        },
    });
}

export function getDeviceInfo(subscriberId) {
    return HttpClient({
        method: 'POST',
        url: `${osstmofiberPath}/get_device_info`,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        },
        data: {
            target_id: subscriberId,
            target_type: 1,
        },
    });
}

export function deleteDeviceInfo(subscriberId, deviceType, serialNumber) {
    return HttpClient({
        method: 'POST',
        url: `${osstmofiberPath}/delete_device_info`,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        },
        data: {
            target_id: subscriberId,
            target_type: 1,
            device_types: [deviceType],
            serial_number: serialNumber,
        },
    });
}

export function addDeviceInfo(deviceInfo, subscriberId) {
    return HttpClient({
        method: 'POST',
        url: `${osstmofiberPath}/add_device_info`,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
        },
        data: {
            target_id: subscriberId,
            target_type: 1,
            device_info: deviceInfo,
        },
    });
}

export default {
    lfAuth,
    getAccount,
    updateResourceMap,
    addDeviceInfo,
};
